<div class="dealer-address">
    <h4 class="dealer-address-title semibold font20">
        {{dealerDetail?.dealerName}}
    </h4>
    <p>{{dealerDetail?.addressLine1}}, {{dealerDetail?.addressLine2}}, {{dealerDetail?.pinCode}} <br>
    {{dealerDetail?.city}}, {{dealerDetail?.country}} </p>
    <br>
    <p>
        <span translate>
            <span translate>lblPhone</span>:
            <a class="wordbreak" href="tel:{{dealerDetail.landlineNumber}}">{{dealerDetail?.landlineNumber}}</a>
        </span>
    <br>
        <span translate>
            <span translate>lblEmail</span>:
            <a class="wordbreak" href="mailto:{{dealerDetail.dealerEmailId}}">{{dealerDetail?.dealerEmailId}}</a>
        </span>
    </p>
</div>